import _ from "lodash";
import React, { useContext } from "react";
import { createUseStyles } from "react-jss";
import { TranslationContext } from "../../umbilical_tools";
import { useHistory } from "react-router-dom";
import { Button } from "../../components/common/Button";
import jssVariables from "../../jss_setup";
import { InlineIcon } from "@iconify/react";

const styles = createUseStyles({
  SuccessfulBooking: (props) => ({
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    zIndex: 9999,
    background: jssVariables.colors.background.light,
    padding: "0 10vw",
    ..._.get(props, "customStyles.SuccessfulBooking", {}),
  }),
  booking: {
    textAlign: "center",
    display: "grid",
    alignContent: "center",
    height: "100%",
    gridGap: `calc(${jssVariables.normal_gap} * 2)`,
    gridAutoRows: "max-content",
    placeContent: "center",
    placeItems: "center",
  },
  successIcon: {
    color: "#5dcb5e",
    fontSize: "xxx-large",
  },
  [`@media ${jssVariables.media.smallscreen}`]: {
    SuccessfulBooking: () => ({ padding: "0 40vw" }),
  },
});

export const SessionLessSuccessfulBooking = () => {
  const classes = styles();
  const { t } = useContext(TranslationContext);
  const history = useHistory();

  const regularMsg = t(
    "shortlyYouReceiveEmailContainingInformationForYourReservation"
  );

  return (
    <div className={classes.SuccessfulBooking}>
      <div className={classes.booking}>
        <InlineIcon icon="ep:success-filled" className={classes.successIcon} />
        <h4>{t("bookingSuccess")}!</h4>
        <h5>{regularMsg}</h5>
        <Button text={t("backToHome")} onClick={() => history.push("/")} />
      </div>
    </div>
  );
};
